[
["1A","Sov. Mil. Order of Malta","EU",15,28],
["3A","Monaco","EU",14,27],
["3B8","Mauritius","AF",39,53],
["3B9","Rodrigues Island","AF",39,53],
["3Y","Bouvet","AF",38,67],
["3C","Equatorial Guinea","AF",36,47],
["3D2","Fiji","OC",32,56],
["3DA","Eswatini","AF",38,57],
["3V","Tunisia","AF",33,37],
["3W","Vietnam","AS",26,49],
["3X","Guinea","AF",35,46],
["4J","Azerbaijan","AS",21,29],
["4L","Georgia","AS",21,29],
["4O","Montenegro","EU",15,28],
["4S","Sri Lanka","AS",22,41],
["4X","Israel","AS",20,39],
["5A","Libya","AF",34,38],
["5B","Cyprus","AS",20,39],
["5H","Tanzania","AF",37,53],
["5N","Nigeria","AF",35,46],
["5R","Madagascar","AF",39,53],
["5T","Mauritania","AF",35,46],
["5U","Niger","AF",35,46],
["5V","Togo","AF",35,46],
["5W","Samoa","OC",32,62],
["5X","Uganda","AF",37,48],
["5Z","Kenya","AF",37,48],
["6W","Senegal","AF",35,46],
["6Y","Jamaica","NA",8,11],
["7O","Yemen","AS",21,39],
["7P","Lesotho","AF",38,57],
["7Q","Malawi","AF",37,53],
["7X","Algeria","AF",33,37],
["8P","Barbados","NA",8,11],
["8Q","Maldives","AS",22,41],
["8R","Guyana","SA",9,12],
["9A","Croatia","EU",15,28],
["9G","Ghana","AF",35,46],
["9H","Malta","EU",15,28],
["9J","Zambia","AF",36,53],
["9K","Kuwait","AS",21,39],
["9L","Sierra Leone","AF",35,46],
["9M2","West Malaysia","AS",28,54],
["9M6","East Malaysia","OC",28,54],
["9N","Nepal","AS",22,42],
["9Q","Dem. Rep. of the Congo","AF",36,52],
["9U","Burundi","AF",36,52],
["9V","Singapore","AS",28,54],
["9X","Rwanda","AF",36,52],
["9Y","Trinidad and Tobago","SA",9,11],
["A2","Botswana","AF",38,57],
["A3","Tonga","OC",32,62],
["A4","Oman","AS",21,39],
["A5","Bhutan","AS",22,41],
["A6","United Arab Emirates","AS",21,39],
["A7","Qatar","AS",21,39],
["A9","Bahrain","AS",21,39],
["AP","Pakistan","AS",21,41],
["BV","Taiwan","AS",24,44],
["BY","China","AS",24,44],
["C2","Nauru","OC",31,65],
["C3","Andorra","EU",14,27],
["C5","Gambia","AF",35,46],
["C6","Bahamas","NA",8,11],
["C9","Mozambique","AF",37,53],
["CE","Chile","SA",12,14],
["CE0Y","Easter Is.","SA",12,63],
["CE9","Antarctica","AN",12,73],
["RI1AN","Antarctica","AN",12,73],
["CM","Cuba","NA",8,11],
["CN","Morocco","AF",33,37],
["CP","Bolivia","SA",12,12],
["CT","Portugal","EU",14,37],
["CT3","Madeira","AF",33,36],
["CU","Azores","EU",14,36],
["CX","Uruguay","SA",13,14],
["D2","Angola","AF",36,52],
["D4","Cape Verde","AF",35,46],
["D6","Comoros","AF",39,53],
["DL","Fed. Rep. of Germany","EU",14,28],
["DU","Philippines","OC",27,50],
["E3","Eritrea","AF",37,48],
["E7","Bosnia-Herzegovina","EU",15,28],
["EA","Spain","EU",14,37],
["EA6","Balearic Is.","EU",14,37],
["EA8","Canary Is.","AF",33,36],
["EA9","Ceuta and Melilla","AF",33,37],
["EI","Ireland","EU",14,27],
["EK","Armenia","AS",21,29],
["EL","Liberia","AF",35,46],
["EP","Iran","AS",21,40],
["ER","Moldova","EU",16,29],
["ES","Estonia","EU",15,29],
["ET","Ethiopia","AF",37,48],
["EU","Belarus","EU",16,29],
["EX","Kyrgyzstan","AS",17,30],
["EY","Tajikistan","AS",17,30],
["EZ","Turkmenistan","AS",17,30],
["F","France","EU",14,27],
["FG","Guadeloupe","NA",8,11],
["FH","Mayotte","AF",39,53],
["FK","New Caledonia","OC",32,56],
["FM","Martinique","NA",8,11],
["FO","French Polynesia","OC",32,63],
["FP","St. Pierre and Miquelon","NA",5,9],
["FR","Reunion","AF",39,53],
["FS","Saint Martin","NA",8,11],
["FW","Wallis and Futuna","OC",32,62],
["FY","French Guiana","SA",9,12],
["G","England","EU",14,27],
["GD","Isle of Man","EU",14,27],
["GI","Northern Ireland","EU",14,27],
["GJ","Jersey","EU",14,27],
["GM","Scotland","EU",14,27],
["GU","Guernsey","EU",14,27],
["GW","Wales","EU",14,27],
["H4","Solomon Is.","OC",28,51],
["HA","Hungary","EU",15,28],
["HB","Switzerland","EU",14,28],
["HB0","Liechtenstein","EU",14,28],
["HC","Ecuador","SA",10,12],
["HC8","Galapagos Is.","SA",10,12],
["HH","Haiti","NA",8,11],
["HI","Dominican Republic","NA",8,11],
["HK","Colombia","SA",9,12],
["HL","Republic of Korea","AS",25,44],
["HP","Panama","NA",7,11],
["HR","Honduras","NA",7,11],
["HS","Thailand","AS",26,49],
["HV","Vatican","EU",15,28],
["HZ","Saudi Arabia","AS",21,39],
["I","Italy","EU",15,28],
["IS","Sardinia","EU",15,28],
["J2","Djibouti","AF",37,48],
["J3","Grenada","NA",8,11],
["J5","Guinea-Bissau","AF",35,46],
["J6","St. Lucia","NA",8,11],
["J7","Dominica","NA",8,11],
["J8","St. Vincent","NA",8,11],
["JA","Japan","AS",25,45],
["JT","Mongolia","AS",23,32],
["JW","Svalbard","EU",40,18],
["JY","Jordan","AS",20,39],
["K","United States","NA",3,6],
["KG4","Guantanamo Bay","NA",8,11],
["KH0","Mariana Is.","OC",27,64],
["KH2","Guam","OC",27,64],
["KH6","Hawaii","OC",31,61],
["KH8","American Samoa","OC",32,62],
["KL","Alaska","NA",1,1],
["KP2","US Virgin Is.","NA",8,11],
["KP4","Puerto Rico","NA",8,11],
["LA","Norway","EU",14,18],
["LU","Argentina","SA",13,14],
["LX","Luxembourg","EU",14,27],
["LY","Lithuania","EU",15,29],
["LZ","Bulgaria","EU",20,28],
["OA","Peru","SA",10,12],
["OD","Lebanon","AS",20,39],
["OE","Austria","EU",15,28],
["OH","Finland","EU",15,18],
["OH0","Aland Is.","EU",15,18],
["OK","Czech Republic","EU",15,28],
["OM","Slovak Republic","EU",15,28],
["ON","Belgium","EU",14,27],
["OX","Greenland","NA",40,5],
["OY","Faroe Is.","EU",14,18],
["OZ","Denmark","EU",14,18],
["P2","Papua New Guinea","OC",28,51],
["P4","Aruba","SA",9,11],
["PA","Netherlands","EU",14,27],
["PJ2","Curacao","SA",9,11],
["PJ4","Bonaire","SA",9,11],
["PJ5","Saba & St Eustatius","SA",8,11],
["PJ6","Saba & St Eustatius","SA",8,11],
["PJ7","Sint Maarten","NA",8,11],
["PY","Brazil","SA",11,15],
["PY0F","Fernando de Noronha","SA",11,13],
["PZ","Suriname","SA",9,12],
["R","Russian Federation","EU",16,29],
["S2","Bangladesh","AS",22,41],
["S5","Slovenia","EU",15,28],
["S7","Seychelles","AF",39,53],
["S9","Sao Tome and Principe","AF",36,47],
["SM","Sweden","EU",14,18],
["SP","Poland","EU",15,28],
["ST","Sudan","AF",34,47],
["SU","Egypt","AF",34,38],
["SV","Greece","EU",20,28],
["SV5","Dodecanese","EU",20,28],
["SV9","Crete","EU",20,28],
["T2","Tuvalu","OC",31,65],
["T5","Somalia","AF",37,48],
["T7","San Marino","EU",15,28],
["T8","Palau","OC",27,64],
["TA","Turkey","AS",20,39],
["TF","Iceland","EU",40,17],
["TG","Guatemala","NA",7,11],
["TI","Costa Rica","NA",7,11],
["TJ","Cameroon","AF",36,47],
["TK","Corsica","EU",15,28],
["TL","Central African Rep.","AF",36,47],
["TN","Republic of the Congo","AF",36,52],
["TR","Gabon","AF",36,52],
["TT","Chad","AF",36,47],
["TU","Cote d Ivoire","AF",35,46],
["TY","Benin","AF",35,46],
["TZ","Mali","AF",35,46],
["UA","Russian Federation","EU",16,29],
["UA2","Kaliningrad","EU",15,29],
["UA9","Asiatic Russia","AS",16,30],
["UK","Uzbekistan","AS",17,30],
["UN","Kazakhstan","AS",17,30],
["UR","Ukraine","EU",16,29],
["V2","Antigua and Barbuda","NA",8,11],
["V3","Belize","NA",7,11],
["V4","St. Kitts and Nevis","NA",8,11],
["V5","Namibia","AF",38,57],
["V6","Micronesia","OC",27,65],
["V7","Marshall Is.","OC",31,65],
["V8","Brunei","OC",28,54],
["VE","Canada","NA",1,2],
["VK","Australia","OC",29,55],
["VK9N","Norfolk Is.","OC",32,60],
["VK9X","Christmas Is.","OC",29,54],
["VP2E","Anguilla","NA",8,11],
["VP2M","Montserrat","NA",8,11],
["VP5","Turks and Caicos Is.","NA",8,11],
["VP6","Pitcairn Is.","OC",32,63],
["VP8","Falkland Is.","SA",13,16],
["VP9","Bermuda","NA",5,11],
["VR","Hong Kong","AS",24,44],
["VU","India","AS",22,41],
["XE","Mexico","NA",6,10],
["XT","Burkina Faso","AF",35,46],
["XU","Cambodia","AS",26,49],
["XW","Laos","AS",26,49],
["XX9","Macao","AS",24,44],
["XZ","Myanmar","AS",26,49],
["YA","Afghanistan","AS",21,40],
["YB","Indonesia","OC",28,51],
["YI","Iraq","AS",21,39],
["YJ","Vanuatu","OC",32,56],
["YK","Syria","AS",20,39],
["YL","Latvia","EU",15,29],
["YN","Nicaragua","NA",7,11],
["YO","Romania","EU",20,28],
["YS","El Salvador","NA",7,11],
["YU","Serbia","EU",15,28],
["YV","Venezuela","SA",9,12],
["Z2","Zimbabwe","AF",38,53],
["Z3","North Macedonia","EU",15,28],
["Z6","Kosovo","EU",15,28],
["Z8","South Sudan","AF",34,48],
["ZA","Albania","EU",15,28],
["ZB","Gibraltar","EU",14,37],
["ZD7","St. Helena","AF",36,66],
["ZD8","Ascension Is.","AF",36,66],
["ZF","Cayman Is.","NA",8,11],
["ZL","New Zealand","OC",32,60],
["ZP","Paraguay","SA",11,14],
["ZS","South Africa","AF",38,57]
]
